"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var adhere_ui_conditionalrender_1 = __importDefault(require("@baifendian/adhere-ui-conditionalrender"));
var VerticalFlexLayout_1 = __importDefault(require("./VerticalFlexLayout"));
var selectorPrefix = 'adhere-ui-flex-layout-tool-bar-layout';
/**
 * ToolBarLayout
 * @constructor
 * @param props
 */
var ToolBarLayout = (0, react_1.memo)(function (props) {
  var _a, _b;
  var _c = props.topToolBarItems,
    topToolBarItems = _c === void 0 ? [] : _c,
    _d = props.bottomToolBarItems,
    bottomToolBarItems = _d === void 0 ? [] : _d,
    children = props.children,
    _e = props.className,
    className = _e === void 0 ? '' : _e,
    _f = props.topClassName,
    topClassName = _f === void 0 ? '' : _f,
    _g = props.bottomClassName,
    bottomClassName = _g === void 0 ? '' : _g,
    _h = props.mainAutoWrapClassName,
    mainAutoWrapClassName = _h === void 0 ? '' : _h,
    _j = props.topProps,
    topProps = _j === void 0 ? {} : _j,
    _k = props.bottomProps,
    bottomProps = _k === void 0 ? {} : _k,
    restProps = __rest(props, ["topToolBarItems", "bottomToolBarItems", "children", "className", "topClassName", "bottomClassName", "mainAutoWrapClassName", "topProps", "bottomProps"]);
  var topElement = (0, react_1.useMemo)(function () {
    return react_1.default.createElement(adhere_ui_conditionalrender_1.default, {
      conditional: !!(topToolBarItems || []).length
    }, function () {
      return topToolBarItems.map(function (t, index) {
        return react_1.default.createElement("div", {
          key: index,
          className: "".concat(selectorPrefix, "-toolbar-item")
        }, t);
      });
    });
  }, [topToolBarItems]);
  var bottomElement = (0, react_1.useMemo)(function () {
    return react_1.default.createElement(adhere_ui_conditionalrender_1.default, {
      conditional: !!(bottomToolBarItems || []).length
    }, function () {
      return bottomToolBarItems.map(function (t, index) {
        return react_1.default.createElement("div", {
          key: index,
          className: "".concat(selectorPrefix, "-toolbar-item")
        }, t);
      });
    });
  }, [bottomToolBarItems]);
  var targetTopProps = (0, react_1.useMemo)(function () {
    return __assign({
      fit: false
    }, topProps !== null && topProps !== void 0 ? topProps : {});
  }, [topProps]);
  var targetBottomProps = (0, react_1.useMemo)(function () {
    return __assign({
      fit: false
    }, bottomProps !== null && bottomProps !== void 0 ? bottomProps : {});
  }, [bottomProps]);
  return react_1.default.createElement(VerticalFlexLayout_1.default, __assign({
    className: (0, classnames_1.default)(selectorPrefix, className !== null && className !== void 0 ? className : ''),
    topClassName: (0, classnames_1.default)(topClassName, (_a = {}, _a["".concat(selectorPrefix, "-top")] = (topToolBarItems || []).length, _a)),
    bottomClassName: (0, classnames_1.default)(bottomClassName, (_b = {}, _b["".concat(selectorPrefix, "-bottom")] = (bottomToolBarItems || []).length, _b)),
    mainAutoWrapClassName: (0, classnames_1.default)("".concat(selectorPrefix, "-main-auto-wrap"), mainAutoWrapClassName !== null && mainAutoWrapClassName !== void 0 ? mainAutoWrapClassName : ''),
    topProps: targetTopProps,
    bottomProps: targetBottomProps
  }, restProps, {
    renderTop: topElement,
    renderMain: children,
    renderBottom: bottomElement
  }));
});
ToolBarLayout.displayName = 'ToolBarLayout';
exports.default = ToolBarLayout;